import React from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import "./WhatsAppButton.css";

function WhatsAppButton() {
  return (
    <FloatingWhatsApp
      phoneNumber="94781171177"
      accountName="Hotline Numbers - Agent"
      allowEsc
      allowClickAway
      notification
      notificationSound
      statusMessage="Typically replies within 5 minutes"
      chatMessage="Hi 👋 How can we help you?"
      avatar="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    />
  );
}

export default WhatsAppButton;
